module.exports = __webpack_public_path__ + "img/郭天羿.8221a109.jpg";